// Fechas para mostrar. Las fechas del torneo son días sueltos (YYYY-MM-DD), sin
// hora: se leen como texto y no pasan por Date, así no hay corrimiento de huso.

const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

function partes(fecha: string) {
  const [a, m, d] = fecha.split('-').map(Number) as [number, number, number];
  return { a, m, d, mes: MESES[m - 1] ?? '' };
}

/**
 * "17 de octubre", "17 al 19 de octubre", "30 de septiembre al 2 de octubre",
 * y con el año solo si los dos días no caen en el mismo año.
 */
export function rangoDeFechas(desde: string, hasta: string): string {
  const a = partes(desde);
  const b = partes(hasta);
  if (desde === hasta) return `${a.d} de ${a.mes}`;
  if (a.a !== b.a) return `${a.d} de ${a.mes} de ${a.a} al ${b.d} de ${b.mes} de ${b.a}`;
  if (a.m === b.m) return `${a.d} al ${b.d} de ${b.mes}`;
  return `${a.d} de ${a.mes} al ${b.d} de ${b.mes}`;
}

// ── Días del torneo ───────────────────────────────────────────────────────

const DIAS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

function aUtc(fecha: string): Date {
  const { a, m, d } = partes(fecha);
  return new Date(Date.UTC(a, m - 1, d));
}

/** "Sábado 18" */
export function diaLargo(fecha: string): string {
  return `${DIAS[aUtc(fecha).getUTCDay()]} ${partes(fecha).d}`;
}

/** "Sáb 18" */
export function diaCorto(fecha: string): string {
  return `${DIAS[aUtc(fecha).getUTCDay()]!.slice(0, 3)} ${partes(fecha).d}`;
}

/** Todos los días entre dos fechas, incluidas. Con tope, por si las fechas vienen mal. */
export function diasEntre(desde: string, hasta: string, maximo = 31): string[] {
  const dias: string[] = [];
  const fin = aUtc(hasta).getTime();
  for (let t = aUtc(desde).getTime(); t <= fin && dias.length < maximo; t += 86_400_000) {
    dias.push(new Date(t).toISOString().slice(0, 10));
  }
  return dias;
}
